module.exports = __webpack_public_path__ + "static/media/acessar-url.9199fd26.jpg";